import React from 'react';

export default function Fabric({ width = 64, height = 'auto' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M61.842 61.406c-2.002 2.02-4.13-3.111-6.97-3.111-2.838 0-2.838 3.639-5.676 3.639-2.839 0-2.839-3.64-5.695-3.64-2.857 0-2.839 3.64-5.695 3.64-2.857 0-2.839-3.64-5.677-3.64-2.839 0-2.839 3.64-5.696 3.64-2.856 0-2.838-3.64-5.695-3.64s-2.838 3.64-5.695 3.64-2.857-3.64-5.695-3.64c-2.839 0-4.968 5.113-6.987 3.112-2.02-2.002 3.111-4.13 3.111-6.969 0-2.838-3.639-2.838-3.639-5.677 0-2.838 3.64-2.838 3.64-5.695s-3.64-2.839-3.64-5.695c0-2.857 3.64-2.839 3.64-5.677 0-2.839-3.64-2.839-3.64-5.696 0-2.856 3.64-2.838 3.64-5.695 0-2.856-3.64-2.838-3.64-5.695s3.64-2.857 3.64-5.695c0-2.839-5.096-4.931-3.094-6.95 2.001-2.02 4.13 3.11 6.969 3.11 2.838 0 2.838-3.638 5.695-3.638s2.838 3.639 5.695 3.639 2.839-3.64 5.695-3.64c2.857 0 2.839 3.64 5.677 3.64 2.839 0 2.839-3.64 5.696-3.64 2.856 0 2.838 3.64 5.695 3.64 2.856 0 2.838-3.64 5.695-3.64s2.857 3.64 5.695 3.64c2.839 0 4.967-5.113 6.987-3.112 2.02 2.002-3.111 4.13-3.111 6.97 0 2.838 3.639 2.838 3.639 5.676 0 2.839-3.64 2.839-3.64 5.695 0 2.857 3.64 2.839 3.64 5.695 0 2.857-3.64 2.839-3.64 5.677 0 2.839 3.64 2.839 3.64 5.696 0 2.856-3.64 2.838-3.64 5.695s3.64 2.838 3.64 5.695-4.404 3.512-3.566 6.241c1.11 3.621 5.04 4.422 3.02 6.441l-.018-.036z"
        stroke="#F9F3E5"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
}
